import { useTranslation } from "react-i18next";import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ITEMS = [
'AUTOMATED RENT COLLECTION', '12,400+ UNITS MANAGED', '98% ON-TIME PAYMENTS',
'REAL-TIME DASHBOARDS', 'WHATSAPP NOTIFICATIONS', 'LEASE MANAGEMENT',
'MAINTENANCE WORKFLOWS', 'TENANT PORTAL', 'ROLE-BASED ACCESS'];


export default function Ticker() {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className={`border-y ${isDarkMode ? 'border-white/[0.06] bg-zinc-950' : 'border-black/[0.08] bg-white'} overflow-hidden py-3.5 transition-colors duration-300`}>
            <div
        className="inline-flex whitespace-nowrap"
        style={{ animation: 'ticker-scroll 35s linear infinite' }}>
        
                {doubled.map((item, i) => {return (
            <span key={i} className={`text-[10px] font-medium tracking-[2.5px] uppercase px-8 ${isDarkMode ? 'text-white/25' : 'text-black/30'}`}>
                        {item}
                        <span className="ml-8 text-red-700 opacity-60">{t("empty_key_18")}</span>
                    </span>);}
        )}
            </div>
            <style>{`@keyframes ticker-scroll { to { transform: translateX(-50%); } }`}</style>
        </div>);

}